import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';

import MentorRow from './MentorRow';
import {history} from '../../router';
import {FORMS_URL} from '../../router/urls';

const ArchieveTable = ({ title, rows, slave, setMentor, flows, isMasterMentor }) => {
    const goForm = (event, opts) => {
        event.stopPropagation();
        event.preventDefault();
        const { form_type, process_id } = opts;
        history.push(FORMS_URL({ form_type, process_id}));
    };
    return (
        <div className="reportbox-content">
            <h4>{title}</h4>
            <div className="line"></div>
            <table className="table table-hover table-bordered">
                <thead>
                <tr>
                    <th>№</th>
                    <th>Наименование проекта</th>
                    <th>Поток</th>
                    <th>Дата заявки</th>
                    <th>Статус</th>
                    <th>Заявитель</th>
                    {
                        isMasterMentor ?
                            <th>Исполнитель</th>
                            :
                            ''
                    }
                </tr>
                </thead>
                <tbody>
                {rows.length === 0 ? (
                    <tr><td colSpan={7} style={{ textAlign: 'center' }}>Нет записей</td></tr>
                ) : rows.map((row, idx) => {
                    const flow = flows.find(item => item.id === row.flow_id);
                    return (
                        <tr key={idx} onClick={e=>goForm(e, row)}>
                            <td className='label-num-cell'><span className="no-desktop">№&nbsp;</span> {row.process_id}</td>
                            <td><span className="no-desktop">Наименование проекта:&nbsp;</span> {row.project_name}</td>
                            <td><span className="no-desktop">Поток:&nbsp;</span> {typeof flow !== 'undefined' ? `${flow.name} (${moment(flow.recruitment_date_start).format('DD.MM.YYYY')} - ${moment(flow.recruitment_date_end).format('DD.MM.YYYY')})` : ''}</td>
                            <td><span className="no-desktop">Дата заявки:&nbsp;</span> {moment(row.form_date).format('DD.MM.YYYY')}</td>
                            <td><span className="no-desktop">Статус:&nbsp;</span> {row.process_status}</td>
                            <td><span className="no-desktop">Заявитель:&nbsp;</span> {row.complainant_fio}</td>
                            {
                                isMasterMentor ?
                                    <td>
                                        <span className="no-desktop">Исполнитель:&nbsp;</span>
                                        <MentorRow
                                            mentors={slave}
                                            row={row}
                                            setMentor={setMentor}
                                            settingMentorIsDisable
                                        />
                                    </td>
                                    :
                                    ''
                            }
                        </tr>

                    )
                })}
                </tbody>
            </table>
        </div>
    );
};

const mapStateToProps = state => ({
    flows: state.forms.flows,
});

export default connect(mapStateToProps)(ArchieveTable);
